<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<form novalidate v-on:submit.prevent>
					<div class="row">
						<div class="col-sm-12">
							<h2 id="title-of-block-check">Setup SSO</h2>
							<div
								class="alert alert-info small"
							>Your administrator requires users to use a SSO provider, as you have not been setup yet, please follow these steps to do so.</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
              <b-dropdown class="ml-3" variant="primary" text="Link SSO">
                <b-dropdown-item href="#" v-for="loginOption in externalLoginOptions" :key="loginOption.id" @click="externalSignIn(loginOption)">
                  <i v-if="loginOption.loginMethod === loginMethodsConstant.Microsoft" class="fa-brands fa-windows"></i>
                  <i v-else-if="loginOption.loginMethod === loginMethodsConstant.Okta">
                    <object style="height:12px" data="/img/SSOLogos/okta.svg" type="image/svg+xml"></object></i>
                  Link {{loginOption.name}} Account

                </b-dropdown-item>
              </b-dropdown>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import loginMethods from '@/Constants/loginMethods'


export default {
	name: 'SetupSSO',
	props: ['query'],
	data () {
		return {
  loginMethods:[]
		}
	},
  computed: {
    externalLoginOptions(){
      return this.loginMethods.filter(lm => lm.loginMethod !== loginMethods.Password)
    },
    loginMethodsConstant(){
      return loginMethods;
    }
  },
  async mounted(){
    await this.checkLoginMethods()
  },
	methods: {
    async checkLoginMethods () {
      try{
        const response = await axios.get('Account/LoginMethods', {
          showload: false
        });

        this.loginMethods = response.data;

        if(this.loginMethods.length === 0){
          this.$router.replace({ name: 'Login', query: { returnUrl: this.query.returnUrl } })
          this.$toastr.e('Failed to get SSO configurations', 'Error')
        }

      }catch{
        this.$router.replace({ name: 'Login', query: { returnUrl: this.query.returnUrl } })
        this.$toastr.e('Failed to get SSO configurations', 'Error')
      }
    },
		externalSignIn ({id}) {
      window.location = `${process.env.VUE_APP_IDENTITY_API}ExternalSignIn?provider=${id}&returnUrl=${encodeURIComponent(this.query.returnUrl)}`
		}
	}

}
</script>
